import React from 'react'
import {RentalsTable} from '../../rentals/RentalsTable'
import {useAllRentals} from '../../rentals/gql/useAllRentals'

interface RentalHistoryTableProps {
  boxId: string
}

export const RentalHistoryTable: React.FC<RentalHistoryTableProps> = ({boxId}) => {
  const {
    data: {rentals},
    loading,
    error,
  } = useAllRentals({
    variables: {
      filter: {boxIds: [boxId]},
      pagination: {offset: 0, limit: 2000},
    },
  })

  return <RentalsTable error={error} loading={loading} rentals={rentals ?? []} />
}
